import * as React from "react";
import { FunctionComponent, useState, useEffect } from "react";
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input/input';
import { isValidPhoneNumber, formatPhoneNumber, isPossiblePhoneNumber } from "react-phone-number-input";
import { GeneralLiabilityClaimReport, ClaimType } from "../../../Models/Claim";

interface StepTwoProps {
	nextStep: (step: number, claim: GeneralLiabilityClaimReport,validate:boolean) => void;
	claim: GeneralLiabilityClaimReport;
	showError: boolean;
}

export const StepTwo: FunctionComponent<StepTwoProps> = ({ nextStep, claim, showError }) => {
	//This is general liability step two
	const [shouldScroll, setShouldScroll] = useState<boolean>(true);
	const [occuranceDescription, setOccuranceDescription] = useState<string>(claim.explanation);
	const [street, setStreet] = useState<string>(claim.line1);
	const [city, setCity] = useState<string>(claim.city);
	const [state, setState] = useState<string>(claim.state);
	const [zip, setZip] = useState<string>(claim.zipCode);
	const [isLawsuitFiled, setIsLawsuitFiled] = useState<string>(getLocalStorage("generalclaim-lawsuit"));

	const [showPopup, setShowPopup] = useState<boolean>(false);

	useEffect(() => {
		if (shouldScroll) {
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
			setShouldScroll(false);
		}
	}, [shouldScroll]);

	useEffect(() => {
		if (isLawsuitFiled === "Yes") {
			setShowPopup(true);
		}
		else {
			setShowPopup(false);
		}
	}, [isLawsuitFiled]);

	function getLocalStorage(key: string) {
		return localStorage.getItem(key) || ""
	}

	function isRequired() {
		if (claim.additionalAnswers["altContactRelation"]) {
			return claim.additionalAnswers["altContactRelation"] === "Policyholder";
		}
		return true;
	}

	return <div className="step-two">
		<div className="form-group">
			<p className="force-left col-lg-12 col-sm-12 col-xs-12 control-label">Where was the location of the occurence? (Include City and State)?<span className="red-ast">*</span></p>
		</div>
		<div className="form-group">
			<div className="col-lg-5 col-md-11 col-sm-12 col-xs-11 mobile-padding-down">
				<label htmlFor="policy-street" className="sr-only">Street Name</label>
				<input type="text" id="policy-street" maxLength={45} aria-invalid={showError && street === ""} aria-required aria-describedby="streetError" name="Policy location street name" className="form-control" placeholder="Street" value={street} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
					setStreet(e.target.value);
				}} />
				<p id="streetError" className={showError && street === "" ? "error" : "error-hidden"}>This field is required</p>
			</div>
			<div className="col-lg-3 col-md-5 col-sm-4 col-xs-4">
				<label htmlFor="policy-city" className="sr-only">City</label>
				<input type="text" id="policy-city" maxLength={30} aria-invalid={showError && city === ""} aria-required aria-describedby="cityError" name="Policy location city" className="form-control" placeholder="City" value={city} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
					setCity(e.target.value);
				}} />
				<p id="cityError" className={showError && city === "" ? "error" : "error-hidden"}>This field is required</p>
			</div>
			<div className="col-lg-2 col-md-3 col-sm-3 col-xs-3">
				<label htmlFor="policy-state" className="sr-only">State</label>
				<input type="text" id="policy-state" aria-invalid={showError && state === ""} aria-required aria-describedby="stateError" name="Policy Location state" className="form-control" placeholder="State" maxLength={2} value={state} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
					setState(e.target.value);
				}} />
				<p id="stateError" className={showError && state === "" ? "error" : "error-hidden"}>This field is required</p>
			</div>
			<div className="col-lg-2 col-sm-4 col-md-4 col-xs-4">
				<label htmlFor="policy-zip" className="sr-only">Zipcode</label>
				<input type="text" inputMode="numeric" aria-invalid={showError && zip === ""} aria-required aria-describedby="zipError" pattern="[0-9]*" id="policy-zip" name="Policy location zipcode" className="form-control" placeholder="Zipcode" maxLength={5} value={zip} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
					setZip(e.target.value.replace(/\D/g, ''));
				}} />
				<p id="zipError" className={showError && zip === "" ? "error" : "error-hidden"}>This field is required</p>
			</div>
		</div>

		<div className="form-group damage-description">
			<label className="control-label col-lg-12 col-md-12 col-sm-12 col-xs-12" htmlFor="occurance-explanation">Please give us a description of the occurence<span className="red-ast">*</span>:</label>
			<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
				<textarea id="occurance-explanation" name="Occurance Explanation" aria-invalid={showError && occuranceDescription === ""} aria-required aria-describedby="occuranceDescription" rows={5} value={occuranceDescription} className="form-control" maxLength={425} onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
					setOccuranceDescription(e.target.value);
				}} />
				<p id="occuranceDescription"><strong>Maximum 425 characters.  You have used {occuranceDescription.length} characters.</strong> <br />
					<span className={showError && occuranceDescription === "" ? "error" : "error-hidden"}>This field is required</span>
				</p>
			</div>
		</div>

		<div className="form-group">
			<label htmlFor="driveable-vehicle" className="control-label col-lg-6 col-md-6 col-sm-12 col-xs-12">Has a lawsuit been filed?<span className="red-ast">*</span></label>
			<div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
				<select className="form-control" id="lawsuit-filed" name="Is the Lawsuit Filed?" aria-invalid={showError && isLawsuitFiled === ""} aria-required aria-describedby="lawsuitFiledError" value={isLawsuitFiled} onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
					setIsLawsuitFiled(e.target.value);
					localStorage.setItem("generalclaim-lawsuit", e.target.value);
				}}>
					<option value="">Select...</option>
					<option value="Yes">Yes</option>
					<option value="No">No</option>
				</select>
				{ showPopup ? <p>Please attach paperwork at the end of this form if possible.</p> : null}
				<p id="lawsuitFiledError" className={showError && isLawsuitFiled === "" ? "error" : "error-hidden"}>This field is required</p>
			</div>
		</div>

		<div className="form-group button-group">
			<button className="btn btn-primary col-lg-6 col-sm-6 col-xs-6" type="button" onClick={() => { goToStep(2); }}><i className="fa fa-arrow-left" aria-hidden="true" />&nbsp;BACK</button>
			<button className="btn btn-primary col-lg-6 col-sm-6 col-xs-6" type="button" onClick={() => { goToStep(4); }}><i className="fa fa-arrow-right" aria-hidden="true" />&nbsp;NEXT</button>
            {showError ? <button className="btn btn-warning" type="button" onClick={() => { goToStep(5,true); }}><i className="fa fa-fast-forward" aria-hidden="true" />&nbsp;Step 5</button> : null}
		</div>
	</div>;

	function goToStep(step: number, validate: boolean = false) {
		claim.explanation = occuranceDescription;
		claim.line1 = street;
		claim.city = city;
		claim.state = state;
		claim.zipCode = zip;
		claim.isLawsuitFiled = isLawsuitFiled === "Yes" ? true : false;
		setShouldScroll(true);
		nextStep(step, claim, validate);
	}
}
